/* src/app/core/widgets/tabs/tabs.component.scss */
.tabs {
  list-style-type: none;
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  width: fit-content;
  max-width: 100%;
  padding: 0.3rem;
  margin: 0 0 1.25rem;
  background-color: #f1f5f9;
  border-radius: 0.6rem;
}
.tabs li {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0.5rem 1rem;
  border-radius: 0.45rem;
  font-weight: 600;
  font-size: 0.85rem;
  color: #475569;
  background-color: transparent;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;
}
.tabs li:hover {
  background-color: rgba(15, 23, 42, 0.06);
  color: #1e293b;
}
.tabs li.active,
.tabs li.active:hover {
  background-color: #f99420;
  color: #fff;
  box-shadow: 0 2px 6px rgba(249, 148, 32, 0.35);
}
.tabs li.invalid {
  color: #dc2626;
}
.tabs li.invalid:hover {
  background-color: rgba(220, 38, 38, 0.08);
  color: #dc2626;
}
.tabs li.invalid.active,
.tabs li.invalid.active:hover {
  background-color: #dc2626;
  color: #fff;
  box-shadow: 0 2px 6px rgba(220, 38, 38, 0.35);
}
/*# sourceMappingURL=tabs.component.css.map */
